import { useMemo } from 'react';
import type { ODataGridColumn } from '@inuxe/prime-odata-grid';
import type { IUserManagementResult } from '../../../models/user-management/UserManagementModel';
import UsersActionCell from './components/UsersActionCell';
import UserStatusCell from './components/UserStatusCell';

export function useUserManagementColumns(): ODataGridColumn<IUserManagementResult>[] {
  return useMemo<ODataGridColumn<IUserManagementResult>[]>(
    () => [
      {
        id: 'actions',
        header: 'İşlemler',
        sortable: false,
        filter: false,
        width: 120,
        className: 'grid-action-column',
        actionSticky: 'left',
        body: row => <UsersActionCell row={row} />,
      },
      {
        field: 'id',
        header: 'ID',
        dataType: 'numeric',
        minWidth: 120,
        sortable: true,
        filter: true,
      },
      {
        field: 'userName',
        header: 'Kullanıcı Adı',
        minWidth: 150,
        sortable: true,
        filter: true,
      },
      {
        field: 'email',
        header: 'E-posta',
        minWidth: 200,
        sortable: true,
        filter: true,
      },
      {
        field: 'roles',
        header: 'Roller',
        minWidth: 150,
        sortable: false,
        filter: false,
        body: row => (row.roles?.length ? row.roles.join(', ') : '—'),
      },
      {
        field: 'isActive',
        header: 'Durum',
        width: 120,
        sortable: true,
        filter: true,
        body: row => <UserStatusCell row={row} />,
      },
      {
        field: 'createdAt',
        header: 'Oluşturulma',
        dataType: 'date',
        minWidth: 160,
        sortable: true,
        filter: true,
        body: row =>
          row.createdAt ? new Date(row.createdAt).toLocaleString('tr-TR') : '',
      },
    ],
    []
  );
}
